export const IMAGE_UPLOAD_REQUEST = "IMAGE_UPLOAD_REQUEST";
export const IMAGE_UPLOAD_RECEIVE = "IMAGE_UPLOAD_RECEIVE";
export const IMAGE_UPLOAD_FAILURE = "IMAGE_UPLOAD_FAILURE";
export const RESET_IMAGE_UPLOAD = "RESET_IMAGE_UPLOAD";

export const PREUPLOAD_REQUEST = "PREUPLOAD_REQUEST";
export const PREUPLOAD_RECEIVE = "PREUPLOAD_RECEIVE";
export const PREUPLOAD_FAILURE = "PREUPLOAD_FAILURE";
export const RESET_PREUPLOAD = "RESET_PREUPLOAD";